import ASCIIFolder from 'fold-to-ascii';
import { Buffer } from 'buffer';

const prefix = 'tplui';

export const asleep = async (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
};

export const sleep = (ms) => {
    return new Promise((resolve) => setTimeout(resolve, ms));
};

export const cloneData = (data) => {
    return JSON.parse(JSON.stringify(data));
};

export const formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) {
        return '0 B';
    }
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
};

export const decodePath = (path) => {
    return path.split('|').join('/');
};

export const encodePath = (path) => {
    return path.split('/').join('|');
};

export const getRndKey = (length = 7) => {
    let result = '',
        counter = 0;
    const characterBank = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

    while (counter < length) {
        result += characterBank.charAt(Math.floor(Math.random() * characterBank.length));
        counter += 1;
    }
    return result;
};

export const fileExtension = (filename) => {
    if (filename.startsWith('.')) {
        filename = filename.substring(1);
    }

    const ext = /[.]/.exec(filename) ? /[^.]+$/.exec(filename) : [''];
    return ext[0];
};

export const getRandomColor = () => {
    const letters = '0123456789ABCDEF';
    let color = '#';
    for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
};

export const mergeObject = (origin, updater) => {
    return { ...origin, ...updater };
};

export const sortArrayOfObjectsBy = (data, byKey) => {
    let sortedData;
    if (typeof byKey === 'string') {
        sortedData = data.sort(function (a, b) {
            let x = a[byKey].toLowerCase();
            let y = b[byKey].toLowerCase();
            if (x > y) {
                return 1;
            }
            if (x < y) {
                return -1;
            }
            return 0;
        });
    }

    if (typeof byKey === 'number') {
        sortedData = data.sort(function (a, b) {
            return a[byKey] - b[byKey];
        });
    }
    return sortedData;
};

export const sortObjectByKey = (origin) => {
    /* LAST WORKING
    return (
        Object.keys(origin)
            //.sort((a, b) => a.localeCompare(b))
            .sort()
            .reduce((obj, key) => {
                obj[key] = origin[key];
                return obj;
            }, {})
    ); */
    return Object.keys(origin)
        .sort((a, b) => a.localeCompare(b))
        .reduce((obj, key) => {
            obj[key] = origin[key];
            return obj;
        }, {});
};

export const searchObjectList = (list, key, value) => {
    return list.find((element) => Object.keys(element).includes(key) && element[key] === value);
};

export const extractKeyFromObjectList = (list, key) => {
    return list.map((item) => item[key]);
};

export const validateEmail = (email) => {
    const emailPattern = /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/;
    const res = emailPattern.exec(email);
    return res !== null;
};

export const keeper = (key, value = '') => {
    const safeKey = `${prefix}_${key}`;
    const storageEngine = localStorage;
    if (typeof value === 'string' && value.length === 0) {
        return JSON.parse(storageEngine.getItem(safeKey));
    }
    return storageEngine.setItem(safeKey, JSON.stringify(value));
};

export const keeperRemove = (key, valueIf = '') => {
    const safeKey = `${prefix}_${key}`;
    const storageEngine = localStorage;
    if (
        (typeof valueIf === 'string' && valueIf.length === 0) ||
        valueIf === storageEngine.getItem(safeKey)
    ) {
        return storageEngine.removeItem(safeKey);
    }
};

export const objectToQueryString = (obj) => {
    let str = [];
    for (let p in obj) {
        str.push(`${encodeURIComponent(p)}=${encodeURIComponent(obj[p])}`);
    }
    return str.join('&');
};

export const toLatin128 = (str) => {
    return ASCIIFolder.foldReplacing(str);
};

export const kebabToCamelCase = (str) => {
    str = str.replace(/-./g, (match) => match[1].toUpperCase());
    if (str.startsWith('-')) {
        return str.substring(1);
    }
    return str;
};

export const camelToKebabCase = (str) => {
    str = str.replace(/[A-Z]/g, (match) => '-' + match.toLowerCase());
    if (str.startsWith('-')) {
        return str.substring(1);
    }
    return str;
};

export const objectToBase64 = (obj) => {
    const objJsonStr = JSON.stringify(obj);
    return Buffer.from(objJsonStr).toString('base64');
};

export const base64DecodeUTF = (base64Str) => {
    const result = Buffer.from(base64Str, 'base64').toString();
    return result;
};
export const base64ToObject = (base64Str) => {
    const result = Buffer.from(base64Str, 'base64').toString();
    return JSON.parse(result);
};

export const stringToCode = (str) => {
    return str
        .replace(/\s+/g, '_')
        .replace(/[^\w-]+/g, '_') // Remove all non-word chars
        .replace(/-/g, '_') // Replace multiple - with single -
        .replace(/__+/g, '_') // Replace multiple - with single -
        .replace(/^_+/, ''); // Trim - from start of str
    //.replace(/_+$/, ''); // Trim - from end of str
};

export const guessValidDbObject = (obj) => {
    return (
        typeof obj === 'object' &&
        (Object.keys(obj).some((k) => k.endsWith('Id')) ||
            Object.keys(obj).some((k) => k === 'id')) &&
        Object.keys(obj).includes('isValid') &&
        obj.isValid === true
    );
};

export const uuidCreate = (version = '4') => {
    let chars = '0123456789abcdef'.split('');
    let uuid = [],
        rnd = Math.random,
        r;
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-';
    uuid[14] = version.toString(); // version 4 ...

    for (let i = 0; i < 36; i++) {
        if (!uuid[i]) {
            r = 0 | (rnd() * 16);
            uuid[i] = chars[i == 19 ? (r & 0x3) | 0x8 : r & 0xf];
        }
    }
    return uuid.join('');
};

export const ark = (o, k, d = '') => {
    return (typeof o === 'object' && o[k]) || d;
};

export const checkVersionFormat = (str) => {
    return /^(\d{1,3})(\.\d{1,3})?$/g.test(str);
};

export const keyToStr = (obj, kmap = []) => {
    /* LAST WORKING
    kmap.map((key) => {
        if (Object.keys(obj).includes(key)) {
            obj[key] = typeof obj[key] === 'string' ? obj[key] : '';
        }
    }); */
    kmap.forEach((key) => {
        if (Object.keys(obj).includes(key)) {
            obj[key] = typeof obj[key] === 'string' ? obj[key] : '';
        }
    });
    return obj;
};

export const composeBackUrl = (router, location) => {
    return router.resolve(location).fullPath;
};

export const resolveBackUrl = (router, route, fallback = 'dashboard') => {
    const value = Array.isArray(route.query.from) ? route.query.from[0] : route.query.from || '';

    if (!value || typeof value !== 'string' || !value.startsWith('/')) {
        return { name: fallback };
    }

    const resolved = router.resolve(value);

    if (!resolved.name) {
        return { name: fallback };
    }

    return {
        name: resolved.name || undefined,
        params: resolved.params || undefined,
        query: resolved.query || undefined,
        hash: resolved.hash || undefined,
    };
};

export const utils = () => {
    return {
        sleep: sleep,
        asleep: asleep,
        cloneData: cloneData,
        formatBytes: formatBytes,
        decodePath: decodePath,
        encodePath: encodePath,
        getRndKey: getRndKey,
        fileExtension: fileExtension,
        getRandomColor: getRandomColor,
        mergeObject: mergeObject,
        sortArrayOfObjectsBy: sortArrayOfObjectsBy,
        sortObjectByKey: sortObjectByKey,
        searchObjectList: searchObjectList,
        extractKeyFromObjectList: extractKeyFromObjectList,
        keeper: keeper,
        objectToQueryString: objectToQueryString,
        validateEmail: validateEmail,
        toLatin128: toLatin128,
        objectToBase64: objectToBase64,
        base64DecodeUTF: base64DecodeUTF,
        base64ToObject: base64ToObject,
        camelToKebabCase: camelToKebabCase,
        kebabToCamelCase: kebabToCamelCase,
        stringToCode: stringToCode,
        guessValidDbObject: guessValidDbObject,
        uuidCreate: uuidCreate,
        ark: ark,
        checkVersionFormat: checkVersionFormat,
        keyToStr: keyToStr,
        composeBackUrl: composeBackUrl,
        resolveBackUrl: resolveBackUrl,
    };
};

export default utils;
